<style scoped>
.main1 {
  width: 100%;
  min-height: 100%;
}
.content {
  width: 375px;
  margin: 0 auto;
  font-family: PingFangSC;
}
.banner {
  width: 100%;
  height: 100px;
  background-image: linear-gradient(to right, #8861f5, #31e6b5);
}
.banner .user-info {
  width: 375px;
  height: 100px;
  margin: 0 auto;
}
.user-info .pay {
  display: flex;
  justify-content: space-between;
  line-height: 25px;
  color: #ffffff;
  font-size: 28px; /*px*/
  padding: 20px; /*px*/
  font-weight: bold;
}

.user-info .order {
  padding-top: 10px; /*px*/
  display: flex;
  line-height: 25px;
  color: #ffffff;
  font-size: 28px; /*px*/
}
.user-info .order span {
  padding: 10px; /*px*/
}

.pay .number {
  font-size: 24px;
}
.cashier-title {
  width: 100%;
  height: 60px;
  background: #ffffff;
}
.logo {
  width: 375px;
  height: 60px;
  margin: 0 auto;
  padding: 18px;
}
.logo img {
  width: 340px; /*px*/
  height: 62px; /*px*/
}

.sucess-box .description {
  color: #515f68;
  font-size: 28px; /*px*/
  padding-top: 22px; /*px*/
  font-weight: bold;
  text-align: center;
}

.sucess-box .sucess-icon {
  width: 100px;
  height: 100px;
  margin: 50px auto 0px auto;
  background: url(./../../assets/img/sucess.png) center no-repeat;
}
.sucess-box .failed-icon {
  width: 100px;
  height: 100px;
  margin: 50px auto 0px auto;
  background: url(./../../assets/img/failed.png) center no-repeat;
}

.cancel {
  text-align: center;
  padding: 32px; /*px*/
  color: #8497a4;
}

.failed-description {
  text-align: center;
  font-size: 24px; /*px*/
  color: #8398a7;
  margin: 11px auto 0 auto;
}

.timer {
  margin: 32px auto;
  line-height: 40px; /*px*/
  text-align: center;
  color: #8398a7;
}
.back-text {
  text-align: center;
  padding-top: 40px;
  color: #1dcf9f;
}
.safe {
  display: flex;
  line-height: 48px; /*px*/
  text-align: center;
  justify-content: center;
  color: #8497a4;
  padding-top: 100px;
}
.safe span {
  display: inline-block;
  height: 48px; /*px*/
  width: 48px; /*px*/
  background: url(./../../assets/img/safe.png) left center no-repeat;
}
.safe a {
  color: #1dcf9f;
  padding-left: 10px;
  text-decoration: none;
}

.err {
  color: #ff2e62;
}
</style>
<template>
  <div class="main1">
    <div class="content">
      <!-- 成功 -->
      <div class="sucess-box" v-if="status === 'SUCCESS'">
        <div class="sucess-icon"></div>
        <p class="description">Transaction accepted by Bank</p>
        <p class="failed-description">Estimated entry time:24 hours</p>
      </div>
      <!-- 失败 -->
      <div class="sucess-box" v-if="status !== 'SUCCESS'">
        <div class="failed-icon"></div>
        <p class="description">Transaction is unsuccessful</p>
        <p class="failed-description">Please try again…</p>
      </div>
      <!-- 倒计时 -->
      <div class="timer">({{qrTime}}s)</div>
    </div>
  </div>
</template>


<script>
import { getParam } from "./../../assets/utils/getParam.js";
export default {
  data() {
    return {
      status: "SUCCESS",
      parms: null,
      orderStatus: "",
      qrTime: "",
      returnUrl: "",
      reason: ""
    };
  },
  created() {
    if (getParam() !== {}) {
      this.parms = JSON.parse(sessionStorage.getItem("opay-parms"));
      let data = getParam();

      // 针对Card支付跳转商家再次回跳支付结果页特殊处理
      if (!this.parms) {
        data = data.data || "{}";
        this.parms = JSON.parse(data);
      }
      this.status = data.orderStatus || "";
      this.returnUrl = this.parms.returnUrl || "";
      this.reason = data.reasonMsg || "";
      if(this.status === "SUCCESS"){
        // 成功
        // this.$dataBuried('H5TOP_S_SHOW');
        this.$dataBuried('h5top_s_show');
      }else{
        // 失败
        // this.$dataBuried('H5TOP_F_SHOW');
        this.$dataBuried('h5top_f_show');
      }
    }
  },
  mounted() {
    this.timer(9, "qrTime", this.back);
  },
  methods: {
    back() {
      window.location.href = this.returnUrl;
    },
    // 倒计时
    timer(time, key, callBack) {
      time = time * 1;
      let timer = setInterval(() => {
        time--;
        if (time <= 0) {
          callBack();
          clearInterval(timer);
        }
        this[key] = time;
      }, 1000);
    }
  }
};
</script>
